import { application } from "../controllers/application"
import { registerControllers } from "stimulus-vite-helpers"

// Register all controllers using stimulus-vite-helpers
// Note: Now includes both .js and .ts files during migration
const controllers = import.meta.glob("../controllers/**/*_controller.{js,ts}", { eager: true })
registerControllers(application, controllers)

// Log registered controllers in development
if (application.debug) {
  const controllerNames = Object.keys(controllers)
    .map(path => path.match(/([^/]+)_controller\.(js|ts)$/)?.[1])
    .filter(Boolean)
    .sort()
  
  console.log('[Stimulus] Registered controllers:', controllerNames)
}

export { application }

